"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerLogger = void 0;
const client_cloudwatch_logs_1 = require("@aws-sdk/client-cloudwatch-logs");
const express_http_context_1 = __importDefault(require("express-http-context"));
const winston_1 = __importDefault(require("winston"));
const winston_cloudwatch_1 = __importDefault(require("winston-cloudwatch"));
const constants_1 = require("../../../constants");
const share_1 = require("../../../utils/share");
const UPLOAD_INTERVAL = 2000;
class ServerLogger {
    constructor(logGroupName) {
        this.logGroupName = logGroupName;
        const consolePrintFormat = winston_1.default.format.printf((info) => {
            const log = `[${info.level}]${this.isStringLogMessage(info.message) ? info.message[0] : JSON.stringify(info.message)}`;
            const reqId = express_http_context_1.default.get(constants_1.LOGGER_CONTEXT_RID_KEY);
            return info.stack ? `[${reqId}]${log}\n${info.stack}` : `[${reqId}]${log}`;
        });
        this.logger = winston_1.default.createLogger({
            format: winston_1.default.format.combine(winston_1.default.format.errors({ stack: true }), consolePrintFormat),
            transports: this.getLoggerTransports()
        });
        this.getLoggerTransports = this.getLoggerTransports.bind(this);
        this.debug = this.debug.bind(this);
        this.info = this.info.bind(this);
        this.warn = this.warn.bind(this);
        this.error = this.error.bind(this);
    }
    getLoggerTransports() {
        const transports = [];
        if (!constants_1.IS_LOCAL_DEV) {
            const cwLogs = new client_cloudwatch_logs_1.CloudWatchLogs({
                region: constants_1.ENV_REGION
            });
            transports.push(new winston_cloudwatch_1.default({
                cloudWatchLogs: cwLogs,
                messageFormatter: (logObject) => {
                    logObject.message = this.isStringLogMessage(logObject.message)
                        ? logObject.message[0]
                        : JSON.stringify(logObject.message);
                    const reqId = express_http_context_1.default.get(constants_1.LOGGER_CONTEXT_RID_KEY);
                    const logJSON = Object.assign({ reqId }, logObject);
                    return JSON.stringify(logJSON);
                },
                logGroupName: this.logGroupName,
                logStreamName: (0, share_1.generateUUID)(),
                uploadRate: UPLOAD_INTERVAL
            }));
        }
        else {
            transports.push(new winston_1.default.transports.Console());
        }
        return transports;
    }
    isStringLogMessage(message) {
        return message && message.length === 1 && typeof message[0] === 'string';
    }
    debug(...message) {
        message && this.logger.debug(message, message.slice(-1)[0]);
    }
    error(...message) {
        message && this.logger.error(message, message.slice(-1)[0]);
    }
    info(...message) {
        message && this.logger.info(message, message.slice(-1)[0]);
    }
    warn(...message) {
        message && this.logger.warn(message, message.slice(-1)[0]);
    }
}
exports.ServerLogger = ServerLogger;
